import { render, staticRenderFns } from "./EbookViewer.vue?vue&type=template&id=33b6143e&scoped=true&"
import script from "./EbookViewer.vue?vue&type=script&lang=js&"
export * from "./EbookViewer.vue?vue&type=script&lang=js&"
import style0 from "./EbookViewer.vue?vue&type=style&index=0&id=33b6143e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b6143e",
  null
  
)

export default component.exports